
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeroHeader from "./HeroHeader";
import { useConsensusData } from "../hooks/useConsensusData";
import { ParsedConsensus } from "../Types/types";
import { EtfCard } from "./EtfCard";
import { Loading } from "./Loading";
import { ErrorAlert } from "./ErrorAlert";

const StockHoldingsTable: React.FC = () => {
  const { data, error, loading } = useConsensusData();

  if (error) return <ErrorAlert message={error} />;
  if (loading || !data) return <Loading />;

  let parsed: ParsedConsensus;
  try {
    parsed = JSON.parse(data.response);
  } catch {
    return <ErrorAlert message="Failed to parse response JSON." />;
  }

  return (
    <Container className="py-4">
      <HeroHeader
        title="Uranium Market Analyzer"
        timestamp={data.createdAt}
      />

      <Row xs={1} sm={2} md={3} lg={4} className="g-4">
        {parsed.PerEtfDecision.map((etf) => (
          <Col key={etf.Ticker}>
            <EtfCard etf={etf} timestamp={data.createdAt} />
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default StockHoldingsTable;